exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-a3193554] {\n  background-color: #ffe800 !important;\n  color: black !important;\n  padding-right: 7px !important;\n  padding-left: 7px !important;\n}\n.icon[data-v-a3193554] {\n  margin-right: 3px !important;\n}\n.text[data-v-a3193554] {\n  font-size: 7px !important;\n}\n", ""]);

// exports
